import { intercomService } from '@/services/intercom';

export const useIntercom = () => {
  const openMessenger = () => {
    intercomService.openMessenger();
  };

  return {
    openMessenger
  };
}; 